import { render, staticRenderFns } from "./ContentsList.vue?vue&type=template&id=6b1c5de6&scoped=true&"
import script from "./ContentsList.vue?vue&type=script&lang=js&"
export * from "./ContentsList.vue?vue&type=script&lang=js&"
import style0 from "./ContentsList.vue?vue&type=style&index=0&id=6b1c5de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c5de6",
  null
  
)

export default component.exports